import { useApiConfig } from '../useApiConfig';

import { PROJECTS_QUERY_KEY } from '../../utils/consts';
import { useQueryClient } from '@tanstack/react-query';
import { ProjectsApi } from 'osep-generator-service-client-v1';

function useDeleteProjectMutation() {
  const { getApiConfig, axiosInstance } = useApiConfig();
  const queryClient = useQueryClient();

  const deleteProject = async (id: string) => {
    const config = await getApiConfig();
    const projectPresets = new ProjectsApi(config, undefined, axiosInstance);

    const response = await projectPresets.setProjectHidden(id);
    await queryClient.invalidateQueries({
      predicate: (query) => query.queryKey.includes(PROJECTS_QUERY_KEY),
    });

    return response.data;
  };

  return { deleteProject };
}

export default useDeleteProjectMutation;
